// Public contact details, set at build time (see .env.example):
//   REACT_APP_CONTACT_EMAIL  e.g. support@azamein.com
//   REACT_APP_CONTACT_PHONE  e.g. +1 845 555 0100  (the phone ordering line)
// Anything left empty is simply not shown.
const clean = (v) => (v || '').trim();

export const CONTACT_EMAIL = clean(process.env.REACT_APP_CONTACT_EMAIL);
export const CONTACT_PHONE = clean(process.env.REACT_APP_CONTACT_PHONE);
export const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, '')}`;
